<template>
    <div class="fillOrder_box">
      <div class="title">
        填写订单信息
        <el-button size="mini" @click="tiggerPage" class="backToClose">返回</el-button>
      </div>

      <el-form
        ref="form"
        :model="{list}"
        :inline="false"
      >
        <div v-for="(item,index) in list" :key="index" >
          <div class="date">
            <div class="date-title">
              <img src="../assets/images/home/date.png" alt="">
              <span>请选择参观日期</span>
            </div>
            <div class="date-content">
              <div
                :class="['date-item', (item.selectDate === dateIndex && !item.otherDate) ? 'isActive' : '']"
                v-for="(dateItem, dateIndex) in dateList"
                @click="findIntervalList(dateItem, dateIndex, item)"
                :key="dateIndex">{{dateItem.dateText + '-' + dateItem.text}}</div>
              <div class="other-date">
                <el-date-picker
                  v-model="item.otherDate"
                  type="date"
                  @change="otherDateFindIntervalList(item)"
                  :picker-options="expireTimeOption"
                  placeholder="其他日期">
                </el-date-picker>
              </div>
            </div>
          </div>

          <div class="date">
            <div class="date-title">
              <img src="../assets/images/home/clock.png" alt="">
              <span>请选择数量</span>
            </div>
            <div class="date-content">
              <div :class="['number-box',
                Number(item.otherNumber) === (numberListItemIndex + 1) ? 'isActive' : '']"
                @click="selectNumberEvent(item, numberListItemIndex)"
                v-for="(numberListItem, numberListItemIndex) in numberList"
                :key="numberListItemIndex">{{numberListItem}}</div>
              <div class="other-number">
                <el-input @blur="isNumber(item)" v-model="item.otherNumber"></el-input>
              </div>
            </div>
          </div>

          <div class="date" v-if="item.isOpenInterval === 'T'">
            <div class="date-title">
              <img src="../assets/images/home/pick.png" alt="">
              <span>请选择检票进场时段</span>
            </div>
            <div class="date-content" v-if="item.timeList && item.timeList.length > 0">
              <div
                :class="['time-box',(timeListIndex + 1) % 4 === 0 ? 'noMR':'']"
                @click="item.selectTime = timeListIndex"
                v-for="(timeListItem, timeListIndex) in item.timeList"
                :key="timeListIndex"
                >
                <div :class="[item.selectTime === timeListIndex ? 'isActive' : '']">{{timeListItem.reservationBeginTime + '-' + timeListItem.reservationEndTime}}</div>
                <span>数量: {{timeListItem.surplusStockNum}}</span>
              </div>
            </div>
            <div class="date-content" v-else>
              <div :class="['time-box']">
                <div>{{'暂无时段'}}</div>
              </div>
            </div>
          </div>
          <div class="visitorMsg">
            <template v-if="item.isRealName === 'A_VISITOR' || item.isRealName === 'ALL_VISITOR'">
              <el-table :row-style="{background:'none'}" :header-cell-style="{background:'#F9F9F9'}" :span-method="objectSpanMethod" class="order-table" :default-expand-all='true'  :data='item.orderVisitorList'>
                <el-table-column align='center' label='景点名称'>
                    <template >
                      <span>{{ item.scenicSpotListName }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='产品名称'>
                    <template >
                      <span>{{ item.goodsName }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='数量' width="60px">
                    <template >
                      <span>{{ item.otherNumber }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='单价' width="80px">
                    <template >
                      <span>¥{{ item.lowestPrice }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='姓名'>
                    <template slot-scope='scope'>
                      <el-form-item :prop="'list.' + index + '.orderVisitorList.' + scope.$index + '.visitorName'" :rules="item.isRealName === 'ALL_VISITOR'?[{ required: true, message: '请输入姓名'}] : []">
                        <el-input placeholder="请输入姓名" v-model="scope.row.visitorName"></el-input>
                      </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='证件类型'>
                    <template slot-scope='scope'>
                      <el-form-item :prop="'list.' + index + '.orderVisitorList.' + scope.$index + '.visitorCertificateType'" :rules="item.isRealName === 'ALL_VISITOR'?[{ required: true, message: '请选择证件类型'}]:[]">
                         <el-select
                            v-model="scope.row.visitorCertificateType"
                            style="display:block"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="i in certificateTypes"
                              :key="i.code"
                              :label="i.value"
                              :value="i.code"
                            ></el-option>
                          </el-select>
                      </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='证件号'>
                    <template slot-scope='scope'>
                      <el-form-item :prop="'list.' + index + '.orderVisitorList.' + scope.$index + '.visitorCertificateNo'" :rules="item.isRealName === 'ALL_VISITOR'?[{ required: true, message: '请输入证件号'}]:[]">
                        <el-input placeholder="请输入证件号" v-model="scope.row.visitorCertificateNo"></el-input>
                      </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column v-if="isMobile === 'T'" align='center' label='出行人手机号'>
                    <template slot-scope='scope'>
                        <el-input placeholder="请输入手机号" v-model="scope.row.visitorMobile"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='操作' width="200px">
                    <template slot-scope='scope'>
                        <el-button  @click="resetItem(index, scope.$index)" style="background: #869ECD;color: #FFFFFF;">重置</el-button>
                        <el-button  @click="deleteList(index, scope.$index)" style="background: #869ECD;color: #FFFFFF;">删除</el-button>
                    </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>
      </el-form>
      <el-form ref="formVisitor" :rules="rules" :model="formData" label-width="120px">
        <div class="visitorMsg">
          <div class="headline">
            联系人信息
            <span class="sub">(请准确填写，以免无法接收订单信息)</span>
          </div>
          <div class="msgForm">
            <el-form-item label="联系手机号" :prop="`contactMobile`">
              <el-input v-model="formData.contactMobile" placeholder="请输入联系人手机号码" style="width:340px"></el-input>
            </el-form-item>
            <el-form-item label="手机验证码" :prop="`code`" v-if="codeshow">
              <el-input
                placeholder="请输入验证码"
                v-model="formData.code"
                style="width:210px;margin-right:10px;"
              ></el-input>
              <el-button
                class="verification-btn"
                type="primary"
                style="width:120px;"
                @click="getVerificationCode"
                :disabled="!verificationBtn"
              >
                <template v-if="verificationBtn">发送验证码</template>
                <template v-else>重新获取({{verificationTime}})</template>
              </el-button>
            </el-form-item>
            <el-form-item v-if="contactRealName" label="身份证号" :prop="`contactCardNo`" class="mt20">
              <el-input v-model="formData.contactCardNo" placeholder="请输入联系人手机号码" style="width:340px"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="submitOrder">
          <span>
            数量:
            <span class="highLight bold">{{Number(count)}}</span>
            张
          </span>
          <span>
            总金额：
            <span class="highLight bold">￥{{total}}</span>
          </span>
          <div
            class="submitBtn"
            @click="submitBtn('form')"
            v-loading.fullscreen.lock="fullscreenLoading"
          >立即购买</div>
        </div>
      </el-form>
      <el-dialog
        title="公告"
        :visible.sync="announcementdialogVisible"
        width="30%"
        :before-close="handleCloseAnnouncement"
      >
        <span>{{msg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="announcementdialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import { validaCellPhone, validaIDCardNo, formatDate } from '../utils/validate'
import { qucikBuyCode, sendCode, createOrder, cardtypeList, payAndConfirm, maxQuantit, certificateNo, getDictList, getInfoConfiguration } from '@/api/buyTicket'
import { findIntervalList, getInfo, getProductDetail } from '@/api/buyTicket_xqs'
import { clearInterval, setInterval } from 'timers'

import * as math from 'mathjs'
import { config } from '@/constant/config'
const checkPhone = (rule, value, callback) => {
  if (value) {
    if (validaCellPhone(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的联系手机号'))
    }
  } else {
    callback(new Error('请输入联系手机号'))
  }
}
const checkIDCardNo = (rule, value, callback) => {
  if (value) {
    if (validaIDCardNo(value.toLocaleUpperCase())) {
      callback()
    } else {
      return callback(new Error('请输入正确的身份证号'))
    }
  } else {
    callback(new Error('请输入身份证号'))
  }
}
export default {
  components: {},
  data () {
    return {
      date: null,
      list: [],
      formData: {
        contactMobile: null,
        contactCardNo: null,
        contactCardType: 1,
        code: ''
      },
      rules: {
        visitorCertificateNo: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
        specialCertificate: [{ required: true, message: '请输入特殊证件号', trigger: 'blur' }],
        visitorCertificateNo1: [{ required: true, message: '身份证号错误', trigger: 'blur', validator: checkIDCardNo }],
        visitorName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        visitorCertificateType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        contactMobile: [{ required: true, message: '请输入正确的手机号', trigger: 'change', validator: checkPhone }],
        contactCardNo: [{ required: true, message: '请输入正确的身份证号', trigger: 'change', validator: checkIDCardNo }]
      },
      certificateTypes: [],
      verificationBtn: true,
      verificationTime: 60,
      total: 0, // 总价
      count: 0, // 票数
      timer: null,
      codeshow: false,
      fullscreenLoading: false,
      maxQuantit: null,
      announcementdialogVisible: false,
      msg: '',
      numbers: 0,
      specialCertificateType: null,
      isMobile: 'F',
      dateList: [],
      otherDate: null,
      numberList: [1, 2, 3, 4, 5, 6],
      otherNumber: 1,
      timeList: [],
      isOpenInterval: 'F',
      ticketInfo: false,
      expireTimeOption: {
        disabledDate (date) {
          // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return (
            date.getTime() < Date.now() + 1000 * 3600 * 24 * 2
          )
        }
      },
      hasIdCard: true
    }
  },
  computed: {
    // 根据配置判断是否需要必填联系人证件号
    contactRealName () {
      const ind = this.list.findIndex(
        item => item.isRealName === 'TICKET_HOLDER'
      )
      return ind >= 0
    }
  },
  created () {
    this.list = JSON.parse(this.$route.query.buydataList) // 列表产品信息
    this.getDate()
    this.cardtypeList() // 获取证件类型
  },
  methods: {
    // 获取分时段配置
    getInfo () {
      return new Promise(resolve => {
        getInfo().then(res => {
          if (res.code === 0 && res.data.isOpenInterval === 'T') {
            this.isOpenInterval = 'T'
          }
          resolve()
        })
      })
    },
    // 获取分时段
    async findIntervalList (item, index, listItem) {
      // 重新获取产品价格
      this.getProductlist(item.date)
      listItem.selectDate = index
      listItem.otherDate = null
      this.$set(listItem, 'timeList', null)
      // 是否开启分时段
      // await this.getInfo() //暂时没有分时段，需要时开启
      if (this.isOpenInterval !== 'T') {
        return
      }
      this.$set(listItem, 'isOpenInterval', 'T')
      // 获取分时段
      findIntervalList({
        'goodsId': listItem.goodsId,
        'merchIndustryId': listItem.merchIndustryId,
        'useStartDate': item.date
      }).then(res => {
        if (res.code === 0) {
          let timeList = res.data.filter(item => item.surplusStockNum > 0)
          this.$set(listItem, 'timeList', timeList)
        }
      })
    },
    // 数量改变计算总价格
    countAll () {
      let count = 0
      let total = 0
      this.list.forEach(item => {
        let listLength = item.orderVisitorList.length
        if (listLength > item.otherNumber) {
          item.orderVisitorList.splice(item.otherNumber, (listLength - item.otherNumber))
        } else if (listLength < item.otherNumber) {
          for (let i = 0; i < (item.otherNumber - listLength); i++) {
            item.orderVisitorList.push({
              visitorName: '',
              visitorCertificateType: this.hasIdCard ? '1' : '',
              visitorCertificateNo: ''
            })
          }
        }
        count += Number(item.otherNumber)
        total += Number(item.otherNumber) * Number(item.lowestPrice)
      })
      this.count = count
      this.total = total.toFixed(2)
    },
    // 其他日期事件
    async otherDateFindIntervalList (listItem) {
      this.getProductlist(formatDate('yyyy-MM-dd', listItem.otherDate))
      // await this.getInfo()
      if (this.isOpenInterval !== 'T') {
        return
      }
      this.$set(listItem, 'isOpenInterval', 'T')
      // 获取分时段
      findIntervalList({
        'goodsId': listItem.goodsId,
        'merchIndustryId': listItem.merchIndustryId,
        'useStartDate': formatDate('yyyy-MM-dd', listItem.otherDate)
      }).then(res => {
        if (res.code === 0) {
          let timeList = res.data.filter(item => item.surplusStockNum > 0)
          this.$set(listItem, 'timeList', timeList)
        }
      })
    },
    // 获取产品列表
    getProductlist (date) {
      getProductDetail({
        useDate: date,
        isDistribution: 'F',
        goodsIdList: [this.list[0].goodsId]
      }).then(res => {
        if (res.code === 0) {
          // let goodsIdx = res.data[this.list[0].merchIndustryId].list.findIndex(item => item.goodsId === this.list[0].goodsId)
          if (res.data && res.data.length > 0) {
            // this.list[0].lowestPrice = res.data[this.list[0].merchIndustryId].list[goodsIdx].lowestPrice
            this.list[0].orderVisitorList.forEach(item => {
              item.salePrice = res.data[0].salePrice
            })
            this.list[0].lowestPrice = res.data[0].salePrice
            this.ticketInfo = false
            this.countAll()
          } else {
            //
            this.ticketInfo = true
            this.$message.error('未查询到票信息')
          }
        } else {
          this.$message.error(res.error)
        }
      })
    },
    GetDateStr (AddDayCount) {
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount)// 获取AddDayCount天后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1// 获取当前月份的日期
      var d = dd.getDate()
      return [y + '-' + m + '-' + d, m + '月' + d + '日']
    },
    isNumber (item) {
      if (!item.otherNumber) {
        item.otherNumber = 1
      }
      var n = Number(item.otherNumber)
      if (isNaN(n)) {
        this.$message.error('请输入正确数值')
        item.otherNumber = 1
      }
      if (n > 100) {
        this.$message.error('数量过多')
        item.otherNumber = 1
      }
      this.$set(item, 'otherNumber', item.otherNumber)
      this.countAll()
    },
    // 获取三天日期
    getDate () {
      this.dateList.push({
        text: '今天',
        date: this.GetDateStr(0)[0],
        dateText: this.GetDateStr(0)[1]
      })
      this.dateList.push({
        text: '明天',
        date: this.GetDateStr(1)[0],
        dateText: this.GetDateStr(1)[1]
      })
      this.dateList.push({
        text: '后天',
        date: this.GetDateStr(2)[0],
        dateText: this.GetDateStr(2)[1]
      })
    },
    getInfoConfiguration () {
      getInfoConfiguration('IS_SHOW_CONTACT').then(res => {
        if (res.code === 0 && res.data) {
          this.isMobile = res.data.value
        } else {
          this.isMobile = 'F'
        }
      })
    },
    handleCloseAnnouncement () {
      this.announcementdialogVisible = false
      this.msg = ''
    },
    getStringDicType (type) {
      let index = (this.specialCertificateType || []).findIndex(item => item.code === type)
      if (index !== -1) {
        return this.specialCertificateType[index].value
      } else {
        return type
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        if (rowIndex === 0) {
          return [100, 1]
        } else {
          return [0, 0]
        }
      }
    },
    // 获取特殊身份证
    getDictList (type) {
      getDictList(type).then(res => {
        if (res.code === 0) {
          this.specialCertificateType = res.data
        }
        this.initData()
      })
    },
    // 初始化订单数据
    initData () {
      this.total = 0
      this.count = 0
      this.list.forEach(val => {
        this.count += parseInt(val.otherNumber)
        this.total += val.otherNumber * val.lowestPrice
        this.$set(val, 'orderVisitorList', [])
        for (var i = 0; i < val.otherNumber; i++) {
          val.orderVisitorList.push({
            visitorName: '',
            visitorCertificateType: this.hasIdCard ? '1' : '',
            visitorCertificateNo: ''
          })
        }
        this.findIntervalList(this.dateList[val.selectDate], 0, val) // 获取分时段
      })
      this.total = Number(this.total).toFixed(2)
      if (this.count < 10) {
        this.count = '0' + this.count
      }
    },
    // 获取系统参数配置的最大下单数
    getmaxQuantit () {
      maxQuantit().then(res => {
        if (res.code === 0) {
          this.maxQuantit = parseInt(res.data.value) || Infinity
        } else {
          console.error(res.error)
        }
      })
    },
    toPath (path) {
      this.$router.push(path)
    },
    selectNumberEvent (item, number) {
      item.otherNumber = ++number
      this.countAll()
    },
    // 数量修改
    handleQuantityChange () {
      this.list.map(item => {
        if (item.quantity < 0 || !item.quantity || item.quantity === null || item.quantity === '') { // 数量为空小于0时
          item.quantity = 0
        }
        item.quantity = parseInt(item.quantity) // 数量输入小点
        let length = item.quantity - item.orderVisitorList.length
        if (length > 0) {
          for (let index = 0; index < length; index++) {
            item.orderVisitorList.push({
              visitorName: '',
              visitorCertificateType: this.hasIdCard ? '1' : '',
              visitorCertificateNo: '',
              specialCertificate: '',
              isSupportPrint: 'F'
            })
          }
        } else if (length < 0) {
          for (var i = item.orderVisitorList.length - item.quantity; i > 0; i--) {
            item.orderVisitorList.splice(item.orderVisitorList.length - 1, 1)
          }
        }
        item.total = Number(math.format(item.quantity * item.salePrice, 14)).toFixed(2)
        this.count = item.quantity
        this.total = Number(math.format(item.quantity * item.salePrice, 14))
        return item
      })
      this.total = Number(this.total).toFixed(2)
    },
    cardtypeList () {
      cardtypeList().then(res => {
        if (res.code === 0) {
          this.certificateTypes = res.data
          this.hasIdCard = !!this.certificateTypes.find(val => val.code === '1')
          this.initData()
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          console.error(res.error)
        }
      })
    },
    qucikBuyCode () {
      qucikBuyCode().then(res => {
        if (res.code === 0) {
          this.codeshow = res.data.value !== 'F'
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          console.error(res.error)
        }
      })
    },
    validateInfo () {
      for (let h = 0; h < this.list.length; h++) {
        let item = this.list[h] // 获取产品信息
        let cartProds = this.list[h].orderVisitorList
        let p = 0
        if (cartProds.length === 0) {
          this.$message.error(`${item.scenicSpotListName}至少添加一位游客`)
          return false
        }
        for (let i = 0; i < cartProds.length; i++) {
          if (cartProds.length > 0) {
            p = i + 1
          }
          // 姓名，身份证号码校验
          if (this.list[h].isRealName === 'ALL_VISITOR') {
            if ((cartProds[i].visitorName == null || cartProds[i].visitorName.trim() === '')) {
              this.$message({
                message: `请填写${item.scenicSpotListName + '-' + item.goodsName}出行人${p || ''}的姓名`,
                type: 'error'
              })
              return false
            }
            if (cartProds[i].visitorCertificateNo == null || cartProds[i].visitorCertificateNo.trim() === '') {
              this.$message({
                message: `请填写${item.scenicSpotListName + '-' + item.goodsName}出行人${p || ''}的证件号`,
                type: 'error'
              })
              return false
            }
            // 验证身份证格式
            if (Number(cartProds[i].visitorCertificateType) === 1 && !validaIDCardNo(cartProds[i].visitorCertificateNo.toLocaleUpperCase())) {
              this.$message({
                message: `${item.scenicSpotListName + '-' + item.goodsName}-出行人${p ||
                  ''} 请确认身份证号码是否填写正确`,
                type: 'error'
              })
              return false
            }
          }

          // 姓名，身份证号码校验
          if (this.list[h].isRealName === 'A_VISITOR') {
            const visitors = cartProds.filter(vt => vt.visitorName || vt.visitorCertificateNo)
            if (visitors.length === 0) {
              this.$message.error(`${item.scenicSpotListName + '-' + item.goodsName}至少输入一位游客信息`)
              return false
            }
            if (cartProds[i].visitorName || cartProds[i].visitorCertificateNo || cartProds[i].visitorMobile) {
              if (!cartProds[i].visitorName || !cartProds[i].visitorCertificateType || !cartProds[i].visitorCertificateNo) {
                this.$message.error(`请完善${item.scenicSpotListName + '-' + item.goodsName}的游客${p}信息`)
                return false
              }
              if (cartProds[i].visitorCertificateNo) {
                if (cartProds[i].visitorCertificateType === '1' && !validaIDCardNo(cartProds[i].visitorCertificateNo)) {
                  this.$message.error(`${item.scenicSpotListName + '-' + item.goodsName}-出行人${p} 请确认身份证号码是否填写正确`)
                  return false
                }
              }
            }
          }
        }
      }
      let cartFlag = this.validateRepeatCart(this.list)
      if (cartFlag) {
        this.$message({
          message: '不能填写重复证件号',
          type: 'error'
        })
        return false
      }
      return true
    },
    resetItem (i, j) {
      this.list[i].orderVisitorList[j] = {}
      this.list[i].orderVisitorList.push({})
      this.list[i].orderVisitorList.pop()
    },
    validateFree (carts) {
      // 循环判断是否有重复的
      let flag = false
      let freeNoList = []
      for (let i = 0; i < carts.length; i++) {
        if (carts[i].needSpecialCertificate === 'T') {
          for (let j = 0; j < carts[i].orderVisitorList.length; j++) {
            freeNoList.push(carts[i].orderVisitorList[j].specialCertificate)
          }
        }
      }
      let freeNoList2 = [...new Set(freeNoList)]
      if (freeNoList2.length !== freeNoList.length) {
        flag = true
      }
      return flag
    },
    validateRepeatCart (carts) {
      // 循环判断是否有重复的身份证
      let flag = false
      for (let i = 0; i < carts.length; i++) {
        for (let j = 0; j < carts[i].orderVisitorList.length; j++) {
          const find = carts[i].orderVisitorList[j]
          if (
            find.visitorCertificateNo &&
            find.visitorCertificateNo.trim().length > 0
          ) {
            for (let k = j + 1; k < carts[i].orderVisitorList.length; k++) {
              if (
                find.visitorCertificateNo ===
                  carts[i].orderVisitorList[k].visitorCertificateNo &&
                find.visitorCertificateType ===
                  carts[i].orderVisitorList[k].visitorCertificateType
              ) {
                flag = true
                break
              }
            }
            if (flag) {
              break
            }
          }
        }
        if (flag) {
          break
        }
      }
      return flag
    },
    certificateNo (checkArr) {
      let data = {
        number: checkArr.visitorCertificateNo
      }
      return new Promise((resolve, reject) => {
        certificateNo(data).then(res => {
          resolve(res)
        })
      })
    },
    submitBtn (formName) {
      if (this.ticketInfo) {
        this.$message.error('未查询到票信息')
        return false
      }
      this.$refs[formName].validate(valid => {
        if (valid && this.validateInfo()) {
          this.$refs.formVisitor.validate(res => {
            if (res) {
              this.saveOrder()
            }
          })
        }
      })
    },
    saveOrder () {
      this.fullscreenLoading = true
      // 获取选择的时间
      const uniteTripCreateList = []
      this.list.forEach(item => {
        // 是否开启时段选择时段
        if (item.isOpenInterval === 'T') {
          if (!item.timeList || item.timeList.length <= 0) {
            this.$message.error(`${item.scenicSpotListName + '-' + item.goodsName},当天暂无时段可预约`)
            return
          }
        }
        if (item.otherNumber > 0) {
          // 其他日期
          let useStartDate = item.otherDate ? formatDate('yyyy-MM-dd', item.otherDate) : this.dateList[item.selectDate].date
          // 将身份证转换成大写
          item.orderVisitorList.forEach(item => {
            item.visitorCertificateNo = item.visitorCertificateNo.toLocaleUpperCase()
          })
          if (item.isRealName === 'A_VISITOR' || item.isRealName === 'ALL_VISITOR') {
            const visitors = item.orderVisitorList.filter(vt => vt.visitorName && vt.visitorCertificateType && vt.visitorCertificateNo)
            let visitor = visitors.length > 0 ? visitors[0] : null
            item.newVisitorList = []
            for (let i = 0; i < item.otherNumber; i++) {
              let visitorMap = null
              if (visitor) {
                if (i < visitors.length) {
                  visitor = visitors[i]
                }
                visitorMap = {
                  visitorCertificateType: visitor.visitorCertificateType,
                  visitorCertificateNo: visitor.visitorCertificateNo,
                  visitorName: visitor.visitorName,
                  visitorMobile: visitor.visitorMobile
                }
              }
              item.newVisitorList.push(visitorMap)
            }
          }
          uniteTripCreateList.push({
            visitorList: (item.isRealName === 'A_VISITOR' || item.isRealName === 'ALL_VISITOR') ? item.newVisitorList : null,
            goodsId: item.goodsId,
            quantity: item.otherNumber,
            useStartDate: useStartDate,
            intervalStockCalenderId: (item.timeList && item.timeList.length > 0) ? item.timeList[item.selectTime].intervalStockCalenderId : null
          })
        }
      })
      const params = {
        contactMobile: this.formData.contactMobile,
        contactCardNo: this.formData.contactCardNo,
        contactCardType: this.formData.contactCardType,
        merchId: config.MERCHID,
        uniteTripCreateList
      }
      createOrder(params).then(res => {
        if (res.code === 0) {
          this.fullscreenLoading = false
          // this.saveFreeOrder(res.data.orderNo,this.list,params)
          this.$router.push({
            path: '/payOrder',
            query: {
              orderNo: res.data,
              goodsNum: this.count,
              ticketList: this.list
            }
          })
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
          this.fullscreenLoading = false
        } else {
          this.fullscreenLoading = false
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    deleteList (index, ind) {
      this.list[index].orderVisitorList.splice(ind, 1)
      this.list[index].selectNum -= 1
      this.list[index].otherNumber--
      // 如果数量少于1，跳回首页
      if (this.count <= 0) {
        this.tiggerPage()
      }
      this.countAll()
    },
    // 免费订单支付接口
    saveFreeOrder (orderNo, orderList, orderData) {
      const data = {
        orderNo
      }
      payAndConfirm(data).then(res => {
        this.fullscreenLoading = false
        if (res.code === 0) {
          this.$router.push({
            path: '/paySucceed',
            query: {
              orderData: JSON.stringify(orderData),
              moduleType: 'TRIP'
            }
          })
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
          this.$router.push({
            path: '/payFailed',
            query: {
              moduleType: 'TRIP'
            }
          })
        }
      })
    },
    tiggerPage () {
      this.$router.go(-1)
    },
    getVerificationCode () {
      if (!validaCellPhone(this.formData.contactMobile)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
      } else {
        const data = {
          templateId: 'SMS_T_BUYCODE',
          mobilePhone: this.formData.contactMobile
        }
        sendCode(data).then(res => {
          if (res.code === 0) {
            this.verificationBtn = false
            this.verificationTime = 60
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
              if (--this.verificationTime <= 0) {
                this.verificationBtn = true
                clearInterval(this.timer)
              }
            }, 1000)
          } else if (res.code === 1017) {
            this.$message({
              message: '登录过期，安全性提醒：请重新登录',
              type: 'error'
            })
          } else {
            this.$message({
              message: res.error,
              type: 'error'
            })
          }
        })
      }
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped lang="scss">
.fillOrder_box {
  padding: 0 70px;
  width: 1140px;
  margin: 104px 0 40px;
  background: white;
  .order-table .el-table__body-wrapper .el-table__row{
    background: none;
  }
  /deep/ .el-table__header {
    th {
      background: #FF9349 !important;
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 21px;
      color: #FFFFFF;
    }
  }
  .el-form-item {
    margin-bottom: 0 !important;
    .el-form-item__error {
      position: initial !important;
      float: left !important;
    }
  }

}

.fillIn-box {
  display: flex;
}
.date {
  margin-bottom: 30px;
  .date-title {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 21px;
      color: #A0393E;
      opacity: 1;
    }
  }
  .date-content {
    display: flex;
    flex-wrap: wrap;
    .isActive {
      background: url('../assets/images/home/select.png') no-repeat;
      background-position: right bottom;
    }
    .other-date {
      width: 198px;
      .el-date-editor {
        width: 100%;
      }
    }
    .date-item {
      width: 203px;
      height: 42px;
      border: 1px solid #A0393E;
      opacity: 1;
      border-radius: 4px;
      line-height: 42px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #1D263A;
      text-align: center;
      margin-right: 109px;
      cursor: pointer;
    }
    .number-box {
      width: 102px;
      height: 42px;
      border: 1px solid #A0393E;
      opacity: 1;
      border-radius: 4px;
      text-align: center;
      line-height: 42px;
      margin-right: 68px;
      cursor: pointer;
    }
    .other-number {
      width: 102px;
      .el-input {
        width: 100%;
      }
    }
    .time-box {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      width: 203px;
      margin-right: 109px;
      margin-bottom: 10px;
      cursor: pointer;
      div {
        width: 203px;
        height: 42px;
        border: 1px solid #A0393E;
        opacity: 1;
        border-radius: 4px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        text-align: center;
        line-height: 42px;
        flex-shrink: 0;
      }
      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #3D5085;
      }
    }
    .noMR {
      margin-right: 0;
    }
  }
}

.title {
  font-size: 24px;
  line-height: 65px;
  font-weight: bold;
  position: relative;
  .back {
    width: 130px;
    height: 44px;
    font-size: 16px;
    text-align: center;
    line-height: 44px;
    cursor: pointer;
    float: right;
    border-radius: 6px;
    background: #241008;
    color: #fff;
  }
  p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #737B8C;
    opacity: 1;
    margin-bottom: 20px;
    line-height: 13px;
  }
  .backToClose {
    position: absolute;
    right: 0;
    top: 20px;
  }
}

// .title::before {
//   content: "";
//   float: left;
//   width: 5px;
//   height: 28px;
//   background-color: #ffe7ae;
//   margin-top: 19px;
//   margin-right: 10px;
// }

.ticket-msg {
  padding-left: 26px;
  p {
    overflow: hidden;
    font-weight: bold;
    font-size: 18px;
    line-height: 46px;
    span {
      float: left;
      width: 120px;
      text-align: left;
      line-height: 46px;
      font-weight: bold;
    }
  }
}

.ticketMsg {
  border: 1px solid #ffe7ae;
  padding: 20px 25px;
  background-color: #fff;
  margin-bottom: 20px;
  position: relative;
}

.ticketMsg p {
  font-size: 18px;
  font-weight: bold;
  color: #4d4d4d;
  line-height: 30px;
}

.blue {
  color: #21a4ff;
  font-weight: bold;
}

.visitorMsg {
  // border: 1px solid #ccc;
  background-color: #fff;
  margin-bottom: 20px;
}

.headline {
  // background-color: #f1f1f1;
  line-height: 46px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 24px;
  color: #424855;
  height: 46px;
}

.headline .sub {
  font-size: 16px;
  font-weight: bold;
}

.sub-sum {
  position: absolute;
  right: 20px;
  bottom: 20px;
  font-size: 18px;
}

.sub-sum .msg {
  float: right;
  font-weight: bold;
}

.sub-sum .price {
  color: #ff6c1a;
  font-weight: bold;
}

.visitorMsg .msgForm {
  // margin: 0 25px;
  padding-top: 13px;
  padding-bottom: 13px;
  border-bottom: 1px solid #ccc;
}
.msgFormNoTop {
  margin: 0 0 !important;
  padding-bottom: 0 !important;
  padding-top: 1px !important;
}
.visitorMsg .msgForm:nth-last-child(1) {
  border-bottom: none;
}
.msgFormTitle2 {
  text-align: center;
  color: #2c3e50;
  font-weight: bold;
  line-height: 40px;
  flex: 1;
}
.msgFormTitle {
  text-align: center;
  color: #2c3e50;
  font-weight: bold;
  line-height: 40px;
  flex: 1;
}
.msgFormTitle::after {
  content: "*";
  color: red;
}
.submitOrder {
  position: relative;
  // border: 1px solid #ccc;
  height: 80px;
  line-height: 80px;
  color: #4d4d4d;
  background-color: #fff;
  text-align: right;
  padding-right: 215px;
  // margin-bottom: 60px;
  font-size: 20px;
}

.submitBtn {
  position: absolute;
  top: 50%;
  right: 32px;
  height: 44px;
  width: 140px;
  line-height: 44px;
  text-align: center;
  font-size: 16px;
  background: #A0393E;
  font-family: PingFang SC;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  margin-top: -29px;
}
.submitBtn:active {
  opacity: 0.8;
}

.el-icon-success {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: goldenrod;
}

.el-icon-error {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: red;
}
.bold {
  font-weight: bold;
  line-height: 37px;
  height: 37px;
  padding: 0 15px;
}
.reservationMsg {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 19px;
  color: #737B8C;
  opacity: 1;
  margin-bottom: 12px;
}
</style>
